import React from "react";
import {IconProps} from "../../../../../icons/icon-props-interface";

const IconPlan: React.FC<IconProps> = ({color = 'var(--color-primary-2-50)'}) => {
    return (
        <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 3C0 2.44772 0.447715 2 1 2H3V16H1C0.447715 16 0 15.5523 0 15V3Z" fill={color}/>
            <path d="M16 2H18C18.5523 2 19 2.44772 19 3V15C19 15.5523 18.5523 16 18 16H16V2Z" fill={color}/>
            <path
                d="M14 0C14.5523 0 15 0.447715 15 1V17C15 17.5523 14.5523 18 14 18H5C4.44772 18 4 17.5523 4 17V1C4 0.447715 4.44772 1.61064e-08 5 0H14ZM7.5 14C7.22386 14 7 14.2239 7 14.5C7 14.7761 7.22386 15 7.5 15H11.5C11.7761 15 12 14.7761 12 14.5C12 14.2239 11.7761 14 11.5 14H7.5ZM6.5 11C6.22386 11 6 11.2239 6 11.5C6 11.7761 6.22386 12 6.5 12H12.5C12.7761 12 13 11.7761 13 11.5C13 11.2239 12.7761 11 12.5 11H6.5ZM9.5 3C8.11929 3 7 4.11929 7 5.5C7 6.88071 8.11929 8 9.5 8C10.8807 8 12 6.88071 12 5.5C12 4.11929 10.8807 3 9.5 3Z"
                fill={color}
            />
        </svg>
    );
}

export default IconPlan;